import { Mic } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAssistantStore } from "../../stores/assistant-store.ts";
import { useAuthStore } from "../../stores/auth-store.ts";
import { AssistantPanel } from "./AssistantPanel.tsx";
import { PrescriptionDraftModal } from "./PrescriptionDraftModal.tsx";

export function AssistantButton() {
	const { t } = useTranslation("assistant");
	const { open, openAssistant, closeAssistant } = useAssistantStore();
	const isAuthed = Boolean(useAuthStore((s) => s.user));

	if (!isAuthed) return null;

	return (
		<>
			<button
				type="button"
				onClick={openAssistant}
				aria-label={t("button.label")}
				className="fixed end-4 sm:end-6 z-40 size-14 rounded-full bg-gradient-brand text-white shadow-lg shadow-brand-500/30 flex items-center justify-center transition-all hover:scale-105 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-300 bottom-[calc(env(safe-area-inset-bottom)+4.75rem)] sm:bottom-6"
			>
				<Mic className="size-6" strokeWidth={2} aria-hidden />
			</button>
			{open && <AssistantPanel onClose={closeAssistant} />}
			{/* Review/confirm modal for a voice-dictated prescription draft —
			    rendered here so it survives the assistant panel closing. */}
			<PrescriptionDraftModal />
		</>
	);
}
